module.exports = __webpack_public_path__ + "img/lucia.772150a7.png";